import { z } from 'zod';
import { zStringRequired } from '../../z';
import { phoneSchema, faxOptionalSchema } from '../shared/phone-fax';
import { applySignatureRefinement, signatureDetailsSchema } from '../shared/signature';
export const patientChoiceValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        from: z.object({
            agencyOrFacility: zStringRequired(),
            address: z.object({
                street: zStringRequired(),
                city: zStringRequired(),
                state: zStringRequired(),
                zip: zStringRequired(),
            }),
            phone: phoneSchema,
            fax: faxOptionalSchema,
        }),
        to: z.object({
            agencyOrFacility: zStringRequired(),
            address: z.object({
                street: zStringRequired(),
                city: zStringRequired(),
                state: zStringRequired(),
                zip: zStringRequired(),
            }),
            phone: phoneSchema,
            fax: faxOptionalSchema,
        }),
        patientAcknowledgment: z.boolean().nullish(),
        signedDate: z.string().nullish(),
        signatureDetails: signatureDetailsSchema,
    })
        .superRefine((data, ctx) => {
        applySignatureRefinement(ctx, data, {
            signatureField: 'patientAcknowledgment',
            signatureMessage: 'Patient acknowledgement is required',
        });
    }),
});
